// extracted by mini-css-extract-plugin
export default {"container":"NoAccess_container__mq2R4","image":"NoAccess_image__v+Qye","title":"NoAccess_title__UsSAn","description":"NoAccess_description__K5OrA"};